import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_UNITS](state, data) {
    console.log('mutation ', data)
    state.allUnits = data
  },
  [types.SAVE_UNIT](state, data) {
    console.log('mutation ', data)
    state.allUnits.push(data)
  },
}
